import { useTranslation } from 'react-i18next';

export function ManualCountGuidance({
  type,
  feeConfigured,
  levelConfigured,
}: {
  type: string;
  feeConfigured: boolean;
  levelConfigured: boolean;
}) {
  const { t } = useTranslation('tournament');
  if (type !== 'TIMED') return <>{t('manualGuidance.displayOnly')}</>;
  if (feeConfigured && levelConfigured) return <>{t('manualGuidance.configured')}</>;
  return (
    <>
      {t('manualGuidance.incomplete')} {!feeConfigured && t('manualGuidance.missingFee')}{' '}
      {!levelConfigured && t('manualGuidance.missingLevel')}
    </>
  );
}
